﻿import config from "../config"
const baseUrl = config.weather_base_url + "species_info/"
export default {
    selectAll: {
        url:  baseUrl + "selectAll",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    }
}

